import {valueStreams} from "./const";

export function getValueStreamsByBranch(branch: string): any[] {
  let valueStreamsList;
  if (branch && valueStreams[branch]?.length > 0) {
    valueStreamsList = valueStreams[branch];
  } else {
    valueStreamsList = [...new Set(Object.values(valueStreams).flat())];
  }
  return valueStreamsList;
}

export function getAllValueStreams() {
  return getValueStreamsByBranch(null);
}

export function getValueStreamColor(valueStream: string, branch: string): string {
  const valueStreamObj = getValueStreamsByBranch(branch).find((d) => d.name === valueStream);
  return valueStreamObj?.color ?? "#ccc";
}
